import { ViewModel } from 'view_models/view_model'
import { TransportationReport } from 'entities/transportation_report'

export class TransportationReportViewModel extends ViewModel<TransportationReport> {
    public pickupDateText = (): string => {
        return this.toDateText(this.object.pickupDate)
    }
    public deliveryDateText = (): string => {
        return this.toDateText(this.object.deliveryDate)
    }

    public receiptRatio = (): number => {
        if (!this.object.sampleSet || !this.object.spitzCount || this.object.sampleSet.length == 0) {
            return 0
        }

        return Math.round((this.object.sampleSet.length / this.object.spitzCount) * 100)
    }

    public inputtedRatio = (): number => {
        if (!this.object.sampleSet || !this.object.spitzCount || this.object.sampleSet.length == 0) {
            return 0
        }

        return Math.round((this.object.sampleSet.filter((s) => s.inspectionStatus != 'DRAFT').length / this.object.spitzCount) * 100)
    }

    public inspectedRatio = (): number => {
        if (!this.object.sampleSet || !this.object.spitzCount || this.object.sampleSet.length == 0) {
            return 0
        }

        return Math.round((this.object.sampleSet.filter((s) => s.inspectionStatus != 'DRAFT' && s.inspectionStatus != 'INPUTTED').length / this.object.spitzCount) * 100)
    }
}
